import { t as createQuizTracker } from "@theme/quiz-analytics";
import { r as submitEmail } from "@theme/submit-quiz-email";
//#region frontend/islands/quiz-form.js
var STEP_NAMES = [
	null,
	"intro",
	"age",
	"weight",
	"shape",
	"breed",
	"condition",
	"portion"
];
var QuizForm = class extends window.HTMLElement {
	connectedCallback() {
		this.currentStep = 1;
		this.totalSteps = 7;
		this.analytics = createQuizTracker("standalone");
		this.analytics.start();
		this.answers = {};
		this.backButton = document.querySelector("#quiz-back-button");
		document.querySelector("[data-current-quiz-step]").textContent = this.currentStep;
		document.querySelector("[data-total-quiz-steps]").textContent = this.totalSteps;
		this.querySelector("[data-quiz-progress-bar]").style.width = `${this.currentStep / this.totalSteps * 100}%`;
		this.querySelectorAll("[data-quiz-next]").forEach((button) => {
			if (!button.dataset.value) button.disabled = true;
		});
		this.addEventListener("input", (e) => {
			const input = e.target.closest("input");
			if (!input) return;
			if (input.inputMode === "numeric") {
				input.value = input.value.replace(/\D/g, "");
				if (input.value !== "" && Number(input.value) > 999) input.value = "999";
				if (input.value !== "" && Number(input.value) < 0) input.value = "0";
			}
			const button = this.querySelector(`[data-quiz-next][data-name="${input.id}"]`);
			if (button) button.disabled = input.value.trim() === "";
		});
		this.addEventListener("click", (e) => {
			const option = e.target.closest("[data-quiz-option]");
			if (option) {
				const name = option.dataset.name;
				this.querySelectorAll(`[data-quiz-option][data-name="${name}"]`).forEach((el) => el.classList.remove("is-selected"));
				option.classList.add("is-selected");
				const hidden = this.querySelector(`#${name}`);
				if (hidden) hidden.value = option.dataset.value;
				const continueBtn = this.querySelector(`[data-quiz-next][data-name="${name}"]`);
				if (continueBtn) continueBtn.disabled = false;
				const descEl = this.querySelector(`[data-quiz-option-description="${name}"]`);
				if (descEl && option.dataset.description) descEl.textContent = option.dataset.description;
				return;
			}
			const button = e.target.closest("[data-quiz-next]");
			if (!button) return;
			const name = button.dataset.name;
			const value = button.dataset.value || this.querySelector(`#${name}`)?.value || "";
			if (button.hasAttribute("data-quiz-email-gate") && !this._emailStepRevealed) {
				this._emailStepRevealed = true;
				this._revealEmailStep();
				return;
			}
			const emailInput = this.querySelector("#quiz-dog-email");
			if (emailInput) this.answers["quiz-dog-email"] = emailInput.value.trim();
			this.nextQuestion(name, value);
		});
		this.backButton?.addEventListener("click", () => this.goBack());
		this.goToStep(1);
	}
	_revealEmailStep() {
		const panel = this.querySelector("[data-quiz-intro-fade]");
		const question = panel?.querySelector("[data-quiz-intro-question]");
		const nameField = panel?.querySelector("[data-quiz-intro-name-field]");
		const emailField = panel?.querySelector("[data-quiz-intro-email-field]");
		if (!panel || !nameField || !emailField) return;
		const swap = () => {
			if (question) question.textContent = "Want your results sent to your inbox? Add your email:";
			nameField.hidden = true;
			emailField.hidden = false;
			emailField.querySelector("input")?.focus();
			requestAnimationFrame(() => requestAnimationFrame(() => {
				panel.style.opacity = "";
			}));
		};
		let done = false;
		const finish = (e) => {
			if (e && (e.target !== panel || e.propertyName !== "opacity")) return;
			if (done) return;
			done = true;
			panel.removeEventListener("transitionend", finish);
			swap();
		};
		panel.style.transition = "opacity 0.25s ease";
		panel.style.opacity = "0";
		panel.addEventListener("transitionend", finish);
		setTimeout(finish, 300);
	}
	goToStep(step) {
		const prev = this.querySelector("[data-step]:not([hidden])");
		this.currentStep = step;
		this.analytics?.stepView(step, STEP_NAMES[step]);
		document.querySelector("[data-current-quiz-step]").textContent = step;
		this.querySelector("[data-quiz-progress-bar]").style.width = `${step / this.totalSteps * 100}%`;
		this.backButton?.toggleAttribute("hidden", step === 1);
		const show = () => {
			this.querySelectorAll("[data-step]").forEach((panel) => {
				panel.hidden = panel.dataset.step !== String(step);
			});
			this.querySelectorAll("[data-quiz-answer]").forEach((el) => {
				el.textContent = this.answers[el.dataset.quizAnswer] ?? "";
			});
			const next = this.querySelector(`[data-step="${step}"]`);
			if (next) {
				next.style.opacity = "0";
				requestAnimationFrame(() => requestAnimationFrame(() => {
					next.style.opacity = "";
				}));
			}
		};
		if (!prev || prev.dataset.step === String(step)) {
			show();
			return;
		}
		let done = false;
		const finish = (e) => {
			if (e && (e.target !== prev || e.propertyName !== "opacity")) return;
			if (done) return;
			done = true;
			prev.removeEventListener("transitionend", finish);
			show();
		};
		prev.style.opacity = "0";
		prev.addEventListener("transitionend", finish);
		setTimeout(finish, 350);
	}
	nextQuestion(name, value) {
		this.answers[name] = value;
		this.analytics?.stepAnswer(this.currentStep, STEP_NAMES[this.currentStep], value);
		if (this.currentStep === 6) {
			this._fetchMealOptions();
			return;
		}
		if (this.currentStep < this.totalSteps) this.goToStep(this.currentStep + 1);
		else this.submit();
	}
	goBack() {
		if (this.currentStep > 1) {
			this.analytics?.stepBack(this.currentStep, STEP_NAMES[this.currentStep]);
			this.goToStep(this.currentStep - 1);
		}
	}
	submit() {
		const mealKey = this.answers["quiz-meal-size"] ?? "full";
		const meal = this.mealOptions?.[mealKey];
		const breed = this.answers["quiz-dog-breed"];
		const params = new URLSearchParams({
			name: this.answers["quiz-dog-name"] ?? "",
			weight: this.answers["quiz-dog-weight"] ?? "",
			condition: this.answers["quiz-dog-condition"] ?? "NONE",
			meal: this.answers["quiz-meal-size"] ?? "full",
			from_quiz: "1",
			quiz_source: "standalone",
			...breed && breed !== "skip" && { breed },
			...meal && {
				variant: meal.variant,
				sellingPlan: meal.sellingPlan
			}
		});
		sessionStorage.setItem("from_quiz", "1");
		if (this.mealOptions && Object.keys(this.mealOptions).length) sessionStorage.setItem("quiz_meal_options", JSON.stringify(this.mealOptions));
		const name = this.answers["quiz-dog-name"];
		const weight = this.answers["quiz-dog-weight"];
		const condition = this.answers["quiz-dog-condition"] ?? "NONE";
		if (!this._completionTracked) {
			this._completionTracked = true;
			const email = this.answers["quiz-dog-email"];
			const variant = this._quizProduct?.variants?.find((v) => String(v.id) === String(meal?.variant));
			const plan = this._quizProduct?.selling_plan_groups?.flatMap((g) => g.selling_plans || []).find((p) => String(p.id) === String(meal?.sellingPlan));
			if (!(!!email && submitEmail(email, {
				name,
				weight,
				condition,
				breed,
				variantId: meal?.variant,
				sellingPlanId: meal?.sellingPlan,
				variantTitle: variant?.title,
				sellingPlanName: plan?.name,
				quizSource: "standalone",
				resultsPath: `/products/${this.dataset.productHandle}?${params}`
			}))) try {
				window.klaviyo?.track("Quiz Finished", {
					name,
					weight,
					condition,
					breed
				});
			} catch (e) {
				console.error("Klaviyo tracking failed:", e);
			}
			this.analytics?.complete({
				weight,
				mealSize: this.answers["quiz-meal-size"] ?? "full",
				conditionCode: condition,
				variantId: meal?.variant,
				variantTitle: variant?.title,
				sellingPlanId: meal?.sellingPlan,
				sellingPlanName: plan?.name
			});
		}
		window.location.href = `/products/${this.dataset.productHandle}?${params}`;
	}
	async _fetchMealOptions() {
		const btn = this.querySelector("[data-quiz-next][data-name=\"quiz-dog-condition\"]");
		const originalText = btn?.textContent;
		if (btn) {
			btn.disabled = true;
			btn.textContent = "Loading...";
		}
		const weight = this.answers["quiz-dog-weight"];
		const condition = this.answers["quiz-dog-condition"] || "NONE";
		const params = new URLSearchParams({
			weight,
			condition
		});
		try {
			const [mealsRes, productRes] = await Promise.all([fetch(`https://happy-howl-app.vercel.app/api/meals?${params}`), fetch(`/products/${this.dataset.productHandle}.js`)]);
			const [data, product] = await Promise.all([mealsRes.json(), productRes.json()]);
			if (!data.error) {
				this.mealOptions = data;
				this._quizProduct = product;
				for (const key of [
					"full",
					"half",
					"quarter"
				]) {
					const meal = data[key];
					if (!meal) continue;
					const variant = product.variants?.find((v) => String(v.id) === String(meal.variant));
					const priceCents = (variant?.selling_plan_allocations?.find((a) => String(a.selling_plan_id) === String(meal.sellingPlan)))?.price ?? variant?.price;
					const el = this.querySelector(`[data-portion-price="${key}"]`);
					if (el && priceCents != null) el.textContent = `$${(priceCents / 100 / (meal.daysOfFood * 2)).toFixed(2)}/meal`;
				}
			}
		} catch {
			this.analytics?.error("meals_fetch_failed");
		}
		if (btn) {
			btn.disabled = false;
			btn.textContent = originalText;
		}
		this.goToStep(7);
	}
};
window.customElements.define("quiz-form", QuizForm);
//#endregion
